import React from 'react';
import './table.scss';

export default props => {

	let { list, onClick } = props

	return (
		<div className='table'>
			<table border="1" className={list.length > 0 ? "rwd-table" :"rwd-table invisible"}>
				<thead>
					<tr>
						{/* <th>Arquivo</th>
						<th>Excluir</th> */}
					</tr>
				</thead>
				<tbody>
					{list.length > 0 && list.map((element, index, array) =>
						<tr key={index}>
							<td width="80%" data-th="Arquivo">{element['text']}</td>
							{/* <td width="30%" data-th="Tamanho">{element.name}</td> */}
							<td width="20%" data-th="Excluir" className="icon">
								<button
									className="cancel-upload-button"
									onClick={() => onClick(element)} type="button">
								</button>
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
}